<template>
  <div class="liquor-master-area">
    <Header active="/liquor/country" />
    <HeaderSelect :list="headerSelectArray" />
    <Background :map="false" />

    <div class="intro">
      <img class="map" src="/liquor/主力产区地图.png" />
      <div class="area">
        <div class="title">什么是产区？</div>
        <div
          class="content"
        >对于大多数葡萄酒入门新手来说，产区概念是开启葡萄酒世界的重要钥匙。所谓“产区”概念，来源于法国葡萄酒体系，“风土（Terroir）”理念， “克里玛（Climats）”文化，和“酒庄（Chateau）”标识，是法国葡萄酒体系中文化底蕴的结晶，以此也形成了“原产地保护”体系，比如脍炙人口的法国“AOC”体系。葡萄酒不同的产区具有不同的自然条件，如积温，降雨量，土壤成分，即便是相同的葡萄在不同的产区也有不同的表现，酿出的葡萄酒味道也风格各异，而同一产区出品的葡萄酒则会形成相对统一的风格，也是消费者了解一款葡萄酒的基础途径。伴随产区概念形成了葡萄酒独特的分级制度，也是葡萄酒在发展历史中形成的规范行业生产、保护生产者声誉、稳定产品质量、维护消费者利益的基础。</div>
      </div>
    </div>

    <div class="new-world-and-old-world">
      <div class="left">
        <div class="title">新世界与旧世界</div>
        <div class="content">
          《世界葡萄酒地图｜World Atlas of Wine》一书被誉为“葡萄酒圣经”，作者约翰逊先生在该书中首次将全球葡萄酒生产国分为两大类：旧世界（Old World）与新世界（New World），它们代表了葡萄酒诞生地的不同风格。
          <br />“旧世界”指的是原始葡萄酒产国，大多位于欧洲和中东地带，包括法国、西班牙、意大利、德国、葡萄牙、奥地利、希腊、黎巴嫩、以色列、克罗地亚、格鲁吉亚、罗马尼亚、匈牙利及瑞士等。旧世界的葡萄酒酿制历史悠久，强调产区分级，酿造方式保守，以多品种混酿为主，酒体结构复杂，香气多样。
          <br />新世界通常指的是欧洲的原殖民地国家，包括美国、新西兰、阿根廷、智利、澳大利亚以及南非等国，其形成规模酿造历史也相对较短。新世界的葡萄酒结合了现代科技方式改良，多以单一品种酿造，果香为主，口感柔顺，跟随市场潮流。
          <br />旧世界好比古典主义画派，高贵典雅，恢宏浑厚，新世界就像波普艺术的横空出世，自由奔放，打破规则。从收藏价值而言，旧世界葡萄酒年份悠久，多为收藏家的追捧对象，而从品鉴享用而言，旧世界与新世界各有千秋。
        </div>
      </div>

      <div class="right">
        <img class="rank" src="/liquor/新世界与旧世界.png" />
        <img src="/liquor/新世界与旧世界2.png" />
      </div>
    </div>

    <div class="world-master-production-area">
      <div class="title">
        <div class="title-before"></div>
        <div class="title-after">世界主要产区</div>
        <div class="title-more" @click="goto('/liquor/area/list')">
          查看更多产区
          <img src="/liquor/menu_arrow@2x.png" alt=">" />
        </div>
      </div>
      <div class="body">
        <div
          class="item"
          v-for="(item, index) in countryList"
          :key="index"
          @click="goto('/liquor/country/' + item.id)"
        >
          <div class="left">
            <img :src="util.getFirstImage(item.map, '180x180')" />
          </div>
          <div class="right">
            <div class="commodity-title">{{item.country}}</div>
            <div class="key-value">
              <div class="key">主要产地：</div>
              <div class="value">{{item.areaList.map(e => e.area).join('/')}}</div>
            </div>
            <div class="key-value">
              <div class="key">国家产区介绍：</div>
              <div class="value">{{item.intro}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import MultiMedia from "@/components/liquor/MultiMedia";
import Background from "@/components/liquor/Background";

export default {
  name: "LiquorMasterArea",
  components: {
    Header,
    Sticky,
    HeaderSelect,
    MultiMedia,
    Background
  },
  data() {
    return {
      headerSelectArray: [
        {
          name: "分类体系",
          link: "/liquor/category",
          active: false
        },
        {
          name: "主力产区",
          link: "/liquor/country",
          active: true
        },
        {
          name: "酿造工艺",
          link: "/liquor/brewing",
          active: false
        }
      ],
      countryList: [],
      areaList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorArea",
        methodName: "retrieve",
        params: {
          numPerPage: 10000
        }
      });
      this.areaList = response.results;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCountry",
        methodName: "retrieve",
        params: {
          focus: true
        }
      });
      console.log(response);
      this.countryList = this.util.sortByPinyin(
        response.results.map(e => {
          return {
            ...e,
            areaList: this.util.sortByPinyin(
              this.areaList.filter(a => a.country === e.country),
              "area"
            )
          };
        }),
        "country"
      );

      console.log(this.countryList);
    },
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-master-area {
  margin-top: 130px;
  position: relative;
  .liquor-background {
    position: absolute;
  }

  .intro {
    // margin-top: -100vh;
    margin: 0 auto;
    padding-top: 50px;
    width: 1100px;
    height: 500px;
    z-index: 100;
    // background: rgba(0, 0, 0, 1);
    // position: relative;

    .map {
      float: left;
      width: 750px;
      margin-left: -150px;
    }

    .area {
      float: right;
      width: 460px;
      //   padding: 20px;
      //   display: inline-block;
      .title {
        height: 33px;
        font-size: 30px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        line-height: 33px;
      }

      .content {
        margin-top: 35px;
        height: 360px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
      }
    }
  }

  .new-world-and-old-world {
    margin: 0 auto;
    width: 1020px;
    margin-top: 20px;
    padding: 40px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

    .left {
      display: inline-block;
      vertical-align: top;
      width: 430px;
      margin-right: 30px;

      .title {
        height: 33px;
        font-size: 30px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(194, 139, 43, 1);
        line-height: 33px;
      }

      .content {
        margin-top: 25px;
        height: 510px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 30px;
      }
    }

    .right {
      vertical-align: top;
      display: inline-block;
      width: 560px;
      img {
        width: 100%;
      }

      .rank {
        margin-top: -120px;
      }
    }
  }

  .world-master-production-area {
    width: 1100px;
    margin: 0 auto;

    .title {
      margin: 30px 0;
      height: 22px;
      font-size: 20px;

      font-weight: normal;
      color: rgba(59, 41, 9, 1);
      line-height: 22px;
    }

    .title-before {
      display: inline-block;
      margin-right: 10px;
      width: 6px;
      height: 12px;
      background: rgba(228, 200, 150, 1);
    }

    .title-after {
      font-family: "FZQKBYSJW";
      display: inline-block;
    }

    .title-more {
      float: right;
      cursor: pointer;
      text-align: center;
      width: 102px;
      height: 23px;
      border: 1px solid rgba(228, 200, 150, 1);
      font-size: 12px;
      font-weight: 400;
      color: rgba(194, 139, 43, 1);
      line-height: 23px;

      img {
        margin-left: 3px;
        width: 4px;
        height: 7px;
      }
    }

    .body {
      .item {
        width: 1060px;
        margin-bottom: 10px;
        padding: 20px;
        background: rgba(250, 250, 250, 1);
        cursor: pointer;

        .left {
          display: inline-block;
          vertical-align: top;
          width: 180px;
          height: 180px;
          margin-right: 20px;

          background: rgba(255, 255, 255, 0.9);

          img {
            width: 180px;
            height: 180px;
          }
        }

        .right {
          display: inline-block;
          vertical-align: top;
          .commodity-title {
            max-width: 858px;
            // height: 25px;
            font-size: 18px;
            font-weight: 600;
            color: rgba(0, 0, 0, 1);
            line-height: 25px;

            margin-bottom: 25px;
          }

          .key-value {
            margin-bottom: 10px;
            .key {
              display: inline-block;
              vertical-align: top;
              width: 120px;
              height: 20px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(132, 135, 145, 1);
              line-height: 20px;
            }

            .value {
              display: inline-block;
              vertical-align: top;
              max-width: 738px;
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
            }
          }
        }
      }

      .item:hover {
        background: rgba(255, 248, 235, 1);
      }
    }
  }
}
</style>